/*
 * Footer link columns: collapsed on mobile, open on desktop.
 *
 * CSS alone cannot do this. The markup ships `open` so that desktop — and any
 * visitor without CSS or JavaScript — sees the links; but a <details> that is
 * genuinely closed cannot be forced open with `display: block`, because
 * browsers hide the content slot itself. So the open state is synced to the
 * breakpoint here.
 *
 * Only syncs when the breakpoint actually changes, never on every resize tick,
 * so a column the shopper opened by hand stays open while they scroll.
 */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';

  function sync(isMobile) {
    document.querySelectorAll('.footer-block__accordion').forEach(function (el) {
      if (isMobile) {
        el.removeAttribute('open');
      } else {
        el.setAttribute('open', '');
      }
    });
  }

  function init() {
    if (!document.querySelector('.footer-block__accordion')) return;

    var mq = window.matchMedia(MOBILE);
    sync(mq.matches);

    var onChange = function (event) {
      sync(event.matches);
    };

    // addEventListener on MediaQueryList is unsupported on older Safari.
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onChange);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
